module.exports = __webpack_public_path__ + "img/MY.27f5325e.svg";